import { combineReducers } from 'redux'
import address from './address'
import application from './application'
import card from './card'
import classifiedCardData from './classifiedCardData'
import common from './common'
import funding from './funding'
import lockPanel from './lockPanel'
import ui from '../features/ui/ui-slice'
import changeAddress from '../features/change-address/change-address-slice'
import fundingInstruments from '../features/funding-instruments/funding-instruments-slice'
import replaceCard from '../features/replace-card/replace-card-slice'
import activateCard from '../features/activate-card/activate-card-slice'
import enrollCard from '../features/enroll-card/enroll-card-slice'
import setPin from '../features/set-pin/set-pin-slice'
import manageCard from '../features/manage-card/manage-card-slice'
import bdmcSummary from '../features/bdmc-summary/bdmc-summary-slice'
import bdmcLockUnlock from '../features/bdmc-lock-unlock/bdmc-lock-unlock-slice'
import bdmcRewards from '../features/bdmc-rewards/bdmc-rewards-slice'
import bdmcEnroll from '../features/bdmc-enroll/bdmc-enroll-slice'
import bdmcRecurringPayments from '../features/bdmc-recurring-payments/bdmc-recurring-payments-slice'
import bdmcCancelCard from '../features/bdmc-cancel-card/bdmc-cancel-card-slice'
import showCard from '../features/show-card/show-card-slice'
import lowBalanceAlert from '../features/low-balance-alert/low-balance-alert-slice'
import requestPhysicalCard from '../features/request-physical-card/request-physical-card-slice'

const reducers = {
  common,
  card,
  classifiedCardData,
  address,
  application,
  funding,
  lockPanel,
  // New flow reducers
  ui,
  changeAddress,
  replaceCard,
  activateCard,
  enrollCard,
  setPin,
  manageCard,
  bdmcSummary,
  bdmcLockUnlock,
  bdmcRewards,
  bdmcEnroll,
  bdmcRecurringPayments,
  bdmcCancelCard,
  showCard,
  lowBalanceAlert,
  requestPhysicalCard,
  fundingInstruments,
}

const otherStateVarsWithoutReducers = [
  'eligibility',
  'returnUri',
  'entryPoint',
  'step',
  'requestedProducts',
  'isMobileNative',
  'experiments',
  'flfr',
  'src',
]

export const REDUCER_STATE_NAMES = Object.keys(reducers).concat(otherStateVarsWithoutReducers)

const passThroughReducersForStateVars = otherStateVarsWithoutReducers.reduce(
  (acc, cur) => ({ ...acc, [cur]: (state = null) => state }),
  {},
)

const rootReducer = combineReducers({
  ...reducers,
  ...passThroughReducersForStateVars,
})

export type RootState = ReturnType<typeof rootReducer>

// Make the untyped `useSelector(state => ...)` calls aware of the app's state
// shape. Without this, react-redux falls back to an empty `DefaultRootState`
// and every `state.<slice>` access fails typecheck.
declare module 'react-redux' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultRootState extends RootState {}
}

export default rootReducer
